export const SET_ACTIVE_CATALOG_TYPE = 'SET_ACTIVE_CATALOG_TYPE'
export const SET_LEFT_PANEL_EXPANDED = 'SET_LEFT_PANEL_EXPANDED'
export const SET_FILTER_IMPORTED_GOODS = 'SET_FILTER_IMPORTED_GOODS'
